import { ProductInfo } from "./ProductInfo";
import { SortText } from "../../../library-js/text/SortText";
import { Rokojori } from "../Rokojori";

export enum StoreStortingType
{
  NAME,
  PRICE
}

export class StoreSortation
{
  type:StoreStortingType;
  reverse:boolean;

  sort( products:ProductInfo[] )
  {
    this.sortByType( products );

    if ( this.reverse )
    {
      products.reverse();
    }
  }

  sortByType( products:ProductInfo[] )
  {
    switch ( this.type )
    {
      case StoreStortingType.NAME:{ this.sortByName( products ); } break;
      case StoreStortingType.PRICE:{ this.sortByPrice( products ); } break;
    }

    //products;
  }

  sortByName( products:ProductInfo[] )
  { 
    SortText.sort( products, p => Rokojori.locale( p.name ) );
  } 

  sortByPrice( products:ProductInfo[] )
  {
    products.sort(
      ( pA, pB )=>
      {
        let sign = Math.sign( ProductInfo.getPriceAsNumber( pA ) - ProductInfo.getPriceAsNumber( pB ) );

        return sign;
      }
    )
  }
}